export default "__VITE_ASSET__BCmqexMb__"